import { startCase } from 'lodash-es'

export default startCase
